import React from 'react';
import {
    BrowserRouter as Router,
    Link
} from "react-router-dom";

import authentication from '../authentication/b2c';
import Gravatar from './gravatar';
import roleUtilities from '../../utilities/roleUtilities';
import api from '../api/api';

const badgeIconByStatus = {
    success: 'fa-check-circle',
    warning: 'fa-exclamation-triangle',
    danger: 'fas fa-exclamation-circle'
};

function Header(props) {
    const orgsPrefix = "/organisation/" + props.organisationId;
    const orgsUrl = orgsPrefix + "/organisations";
    const orgUrl = "/organisation/" + props.organisationId;
    const breachesUrl = orgsPrefix + "/breaches";
    const clientsUrl = orgsPrefix + "/clients";
    const sitesUrl = orgsPrefix + "/sites";
    const enforcementUrl = orgsPrefix + "/enforcement";
    const allowListUrl = orgsPrefix + "/allow-list";
    const disallowListUrl = orgsPrefix + "/disallow-list";
    const cancellationUrl = orgsPrefix + "/cancellation-reasons";
    const appealSupplementaryResponsesUrl = orgsPrefix + "/appeal-supplementary-responses";
    const cameraRawDataUrl = orgsPrefix + "/raw-data/camera-data";
    const kadoeRawDataUrl = orgsPrefix + "/raw-data/kadoe";
    const paymentsRawDataUrl = orgsPrefix + "/raw-data/payments";
    const pcnPaymentsRawDataUrl = orgsPrefix + "/raw-data/pcn-payments";
    const lettersRawDataUrl = orgsPrefix + "/raw-data/letters";
    const auditLogRawDataUrl = orgsPrefix + "/raw-data/audit-log";
    const emailsRawDataUrl = orgsPrefix + "/raw-data/emails";
    const contraventionsUrl = orgsPrefix + "/contravention-settings";
    const debtCollectionProvidersUrl = orgsPrefix + "/debt-collection-providers";
    const tagSettingsUrl = orgsPrefix + "/tag-settings";
    const refNumRangesUrl = orgsPrefix + "/reference-number-ranges";
    const userManagUrl = orgsPrefix + "/user-management";
    const letterTemplatesUrl = orgsPrefix + "/letter-templates";
    const reportsUrl = orgsPrefix + "/reports";
    const notificationsManagementUrl = "/notifications";
    const globalSettingsUrl = "/global-settings";
    const vehicleAnalyticsUrl = orgsPrefix + "/vehicle-analytics";
    const regionsUrl = orgsPrefix + "/regions";
    const suspensionsUrl = orgsPrefix + "/enforcement-suspensions";
    const healthCheckUrl = orgsPrefix + "/health-check";

    const isThirdPartyUser = roleUtilities.isThirdPartyManager(props.user, props.organisationId) || roleUtilities.isThirdPartyProcessor(props.user, props.organisationId)
    return (
        <>
            <nav className="navbar navbar-light navbar-glass navbar-top sticky-kit navbar-expand-lg">
                <button className="btn navbar-toggler-humburger-icon navbar-toggler mr-1 mr-sm-3" type="button" data-toggle="collapse" data-target="#navbarStandard" aria-controls="navbarStandard" aria-expanded="false" aria-label="Toggle Navigation"><span className="navbar-toggle-icon"><span className="toggle-line"></span></span></button>
                <a className="navbar-brand mr-1 mr-sm-3" href="/">
                    <div className="d-flex align-items-center"><img className="mr-2" src="/assets/img/apt-logos/logo.svg" alt="" width="100" />
                    </div>
                </a>
                <div className="collapse navbar-collapse" id="navbarStandard">
                    <ul className="navbar-nav">
                        <li className="nav-item dropdown dropdown-on-hover">
                            <Link to="/" className="nav-link dropdown-toggle" id="navbarDropdownDash" role="button" >Dashboard</Link>
                            <div className="dropdown-menu dropdown-menu-card" aria-labelledby="navbarDropdownDash">
                                <div className="bg-white rounded-soft py-2">
                                    <Link className="dropdown-item" to={breachesUrl}>Breaches</Link>
                                </div>
                            </div>
                        </li>
                        {props.user.isGlobalAdmin &&
                            <li className="nav-item">
                                <Link to={orgsUrl} className="nav-link" role="button" >Organisations</Link>
                            </li>}
                        <li className="nav-item dropdown dropdown-on-hover">
                            <Link to={!isThirdPartyUser && !roleUtilities.isOrganisationProcessor(props.user, props.organisationId) ? orgUrl : ""} className="nav-link dropdown-toggle" id="navbarDropdownOrganisation" role="button" >{props.organisationName}</Link>
                            <div className="dropdown-menu dropdown-menu-card" aria-labelledby="navbarDropdownOrganisation">
                                <div className="bg-white rounded-soft py-2">
                                    <Link className="dropdown-item" to={allowListUrl}>Allow List</Link>
                                </div>
                                <div className="bg-white rounded-soft py-2">
                                    <Link className="dropdown-item" to={disallowListUrl}>Disallow List</Link>
                                </div>
                                {!isThirdPartyUser && !roleUtilities.isOrganisationProcessor(props.user, props.organisationId) && 
                                <>
                                    <div className="bg-white rounded-soft py-2">
                                        <Link className="dropdown-item" to={ appealSupplementaryResponsesUrl }>Appeal Supplementary Responses</Link>
                                    </div>
                                    <div className="bg-white rounded-soft py-2">
                                        <Link className="dropdown-item" to={ cancellationUrl }>Cancellation & Void Reasons</Link>
                                    </div>
                                    <div className="bg-white rounded-soft py-2">
                                        <Link className="dropdown-item" to={ contraventionsUrl }>Contravention Settings</Link>
                                    </div>
                                    <div className="bg-white rounded-soft py-2">
                                        <Link className="dropdown-item" to={ debtCollectionProvidersUrl }>Debt Collection Providers</Link>
                                    </div>
                                    <div className="bg-white rounded-soft py-2">
                                        <Link className="dropdown-item" to={ suspensionsUrl }>Enforcement Suspensions</Link>
                                    </div>
                                    <div className="bg-white rounded-soft py-2">
                                        <Link className="dropdown-item" to={ letterTemplatesUrl }>Letter Templates</Link>
                                    </div>
                                    <div className="bg-white rounded-soft py-2">
                                        <Link className="dropdown-item" to={ refNumRangesUrl }>Reference Number Ranges</Link>
                                    </div>
                                    {roleUtilities.isOrganisationAdminOrManager(props.user, props.organisationId) && 
                                    <div className="bg-white rounded-soft py-2">
                                        <Link className="dropdown-item" to={ regionsUrl }>Regions</Link>
                                    </div>}
                                    <div className="bg-white rounded-soft py-2">
                                        <Link className="dropdown-item" to={ tagSettingsUrl }>Tag Settings</Link>
                                    </div>
                                    {roleUtilities.isOrganisationAdminOrManager(props.user, props.organisationId) && <div className="bg-white rounded-soft py-2">
                                        <Link className="dropdown-item" to={ userManagUrl }>User Management</Link>
                                    </div>}
                                </>}
                            </div>
                        </li>
                        {!isThirdPartyUser && !roleUtilities.isOrganisationProcessor(props.user, props.organisationId) &&
                        <li className="nav-item">
                            <Link to={clientsUrl} className="nav-link">Clients</Link>
                        </li>}
                        <li className="nav-item">
                            <Link to={sitesUrl} className="nav-link">Sites</Link>
                        </li>
                        <li className="nav-item">
                            <Link to={enforcementUrl} className="nav-link">Enforcement</Link>
                        </li>

                        <li className="nav-item dropdown dropdown-on-hover">
                            <div className="nav-link dropdown-toggle" id="navbarDropdownRawData" role="button" >Raw Data</div>
                            <div className="dropdown-menu dropdown-menu-card" aria-labelledby="navbarDropdownRawData">
                                <div className="bg-white rounded-soft py-2">
                                    <Link className="dropdown-item" to={cameraRawDataUrl}>Camera Data</Link>
                                </div>
                                <div className="bg-white rounded-soft py-2">
                                    <Link className="dropdown-item" to={kadoeRawDataUrl}>Kadoe Requests</Link>
                                </div>
                                <div className="bg-white rounded-soft py-2">
                                    <Link className="dropdown-item" to={paymentsRawDataUrl}>Payments</Link>
                                </div>
                                <div className="bg-white rounded-soft py-2">
                                    <Link className="dropdown-item" to={pcnPaymentsRawDataUrl}>PCN Payments</Link>
                                </div>
                                <div className="bg-white rounded-soft py-2">
                                    <Link className="dropdown-item" to={lettersRawDataUrl}>Letters</Link>
                                </div>
                                <div className="bg-white rounded-soft py-2">
                                    <Link className="dropdown-item" to={emailsRawDataUrl}>Emails</Link>
                                </div>
                                {roleUtilities.isOrganisationAdmin(props.user, props.organisationId) && <div className="bg-white rounded-soft py-2">
                                    <Link className="dropdown-item" to={auditLogRawDataUrl}>Audit Log</Link>
                                </div>}
                            </div>
                        </li>
                        {
                            (
                                roleUtilities.isOrganisationAdminOrManager(props.user, props.organisationId) 
                                || roleUtilities.isThirdPartyManager(props.user, props.organisationId)
                                || roleUtilities.isOrganisationProcessor(props.user, props.organisationId)
                            ) &&
                                <li className="nav-item dropdown dropdown-on-hover">
                                    <Link to={reportsUrl} className="nav-link" id="navbarDropdownReports" role="button">Reports</Link>                                    
                                </li>
                        }

                        { props.user !== null && props.user.isGlobalAdmin && 
                        <li className="nav-item dropdown dropdown-on-hover">
                            <div className="nav-link dropdown-toggle" id="navbarDropdownAdminTools" role="button">Admin Tools</div>
                            <div className="dropdown-menu dropdown-menu-card" aria-labelledby="navbarDropdownAdminTools">
                                <div className="bg-white rounded-soft py-2">
                                    <Link className="dropdown-item" to={notificationsManagementUrl}>Notifications</Link>
                                </div>
                                <div className="bg-white rounded-soft py-2">
                                    <Link className="dropdown-item" to={globalSettingsUrl}>Global Settings</Link>
                                </div>
                            </div>
                        </li>}

                        {roleUtilities.isOrganisationAdmin(props.user, props.organisationId) && <li className="nav-item">
                            <Link to={vehicleAnalyticsUrl} className="nav-link">Vehicle Analytics</Link>
                        </li>}
                        
                    </ul>
                </div>
                <ul className="navbar-nav navbar-nav-icons ml-auto flex-row align-items-center">
                    {
                        roleUtilities.isOrganisationAdmin(props.user, props.organisationId) &&
                        <>
                        <li className="nav-item dropdown mr-2 health-check-notification">
                            <a
                                href="#"
                                role="button"
                                id="healthCheckDropdown"
                                className="btn btn-none m-0 p-0 nav-link d-flex align-items-center"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                                onClick={ event => event.preventDefault() }
                            >
                                <span className="position-relative d-inline-block fs-1">
                                    <i className="fas fa-heartbeat"></i>
                                    { props.goLiveChecklistStatus &&
                                        <i className={ `global-status-icon fas ${ badgeIconByStatus[props.goLiveChecklistStatus] } text-${ props.goLiveChecklistStatus } position-absolute` }></i>
                                    }
                                </span>
                            </a>
                                <div className="dropdown-menu dropdown-menu-right dropdown-menu-card dropdown-caret-none" aria-labelledby="healthCheckDropdown">
                                    <div className='card-header border-bottom d-flex justify-content-between align-items-center'>
                                        <p className='m-0 ml-1 fs-1'>Health Check</p>
                                        <Link
                                            type='button'
                                            to={ healthCheckUrl }
                                            className="btn btn-none m-0 p-0 nav-link d-flex align-items-center fs--1">
                                                See all <i className='fas fa-chevron-right ml-1'></i>
                                            </Link>
                                    </div>
                                    <div className='card-body px-0 py-0'>
                                        <Link type='button' to={ { pathname: healthCheckUrl, state: { initialCategory: "danger" } } } className='d-flex justify-content-between align-items-center btn btn-none m-0 p-0 w-100'>
                                            <div className='d-flex align-items-center' style={{
                                                borderLeft: "8px solid #e63757"
                                            }}>
                                                <div className='d-flex flex-column align-items-start py-3 pl-3'>
                                                    <p className='m-0 text-danger font-weight-bold'>Critical <i className='fas fa-exclamation-circle text-danger fs--1'></i></p>
                                                    <small className='m-0'>Blocks day-to-day operations</small>
                                                </div>
                                            </div>
                                            <div className='badge badge-danger mr-3'>
                                                <p className='m-0 fs-1'>{ props.dangerCount }</p>
                                            </div>
                                        </Link>
                                        <Link type='button' to={ { pathname: healthCheckUrl, state: { initialCategory: "warning" } } } className='mt-1 d-flex justify-content-between align-items-center btn btn-none m-0 p-0 w-100'>
                                            <div className='d-flex align-items-center' style={{
                                                borderLeft: "8px solid #f5803e"
                                            }}>
                                                <div className='d-flex flex-column align-items-start py-3 pl-3'>
                                                    <p className='m-0 text-warning font-weight-bold'>Warning <i className='fas fa-exclamation-triangle text-warning fs--1'></i></p>
                                                    <small className='m-0'>Worth reviewing</small>
                                                </div>
                                            </div>
                                            <div className='badge badge-warning mr-3'>
                                                <p className='m-0 fs-1'>{ props.warningCount }</p>
                                            </div>
                                        </Link>
                                        <Link type='button' to={ { pathname: healthCheckUrl, state: { initialCategory: "success" } } } className='mt-1 d-flex justify-content-between align-items-center btn btn-none m-0 p-0 w-100'>
                                            <div className='d-flex align-items-center' style={{
                                                borderLeft: "8px solid #00d27a"
                                            }}>
                                                <div className='d-flex flex-column align-items-start py-3 pl-3'>
                                                    <p className='m-0 text-success font-weight-bold'>Complete <i className='fa fa-check text-success fs--1'></i></p>
                                                    <small className='m-0'>Already good to go</small>
                                                </div>
                                            </div>
                                            <div className='badge badge-success mr-3'>
                                                <p className='m-0 fs-1'>{ props.successCount }</p>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                        </li>
                        </>
                    }
                    <li className="nav-item mr-2">
                        <a className="nav-link px-2 d-flex align-items-center" href="mailto:support@advancedparking.tech" title="Contact Support">
                            <i className='fas fa-user fs-1 mr-1'></i>
                            Support
                        </a>
                    </li>
                    <li className="nav-item dropdown dropdown-on-hover">
                        <a className="nav-link pr-0 user-icon" id="navbarDropdownUser" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            {props.user !== null && props.user !== undefined &&
                                <Gravatar user={props.user} />
                            }
                        </a>
                        <div className="dropdown-menu dropdown-menu-right py-0" aria-labelledby="navbarDropdownUser">
                            <div className="bg-white rounded-soft py-2">
                                {props.user !== undefined && (props.user.organisations.length > 1 || props.user.isGlobalAdmin) &&
                                    <>
                                        <a className="dropdown-item" href="/">Select Organisation</a>
                                        <div className="dropdown-divider"></div>
                                    </>}
                                    {props.user !== null && !isThirdPartyUser && <Link className="dropdown-item" to="/roles">Select Role</Link>}
                                <Link className="dropdown-item" to="/profile-management">Profile Management</Link>
                                <div className="dropdown-divider"></div>
                                <button type="button" className="dropdown-item" data-toggle="modal" data-target="#signOutModal">Sign Out</button>
                            </div>
                        </div>
                    </li>
                </ul>
            </nav>
            <div className="modal fade" id="signOutModal" tabIndex="-1" role="dialog" aria-labelledby="signOutModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="signOutModalLabel">Are you sure you want to Sign Out?</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-falcon-default btn-sm ml-2" data-dismiss="modal">Cancel</button>
                            <button className="btn btn-primary btn-sm" data-dismiss="modal" onClick={() => {
                                api.userLogout(
                                    null,
                                    error => console.log(error),
                                    props.organisationId, props.token
                                )
                                authentication.signOut()
                            }}>Sign Out</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default Header;